import React from 'react'
import { Tag as TagAnt } from 'antd'

import { currencyMask } from 'src/components/Formik'

function TagCurrency({ value }: { value: number }) {
  return (
    <TagAnt
      color="green"
      style={{
        fontSize: 20,
        textAlign: 'center'
      }}
    >
      {`BRL ${
        currencyMask({
          formatStr: true,
          value
        }).maskedValue
      }`}
    </TagAnt>
  )
}

export default TagCurrency
